import {
  useDeletePhotoMutation,
  usePhotosQuery,
  useUploadPhotoMutation,
} from '@features/visits/queries';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import { Box, Button, Divider, Stack } from '@mui/material';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import HairstylePhotoCapture from './visit-detail-photo-capture';
import HairstylePhotoGallery from './visit-detail-photo-gallery';

const VisitDetailPhoto = (props: { visitId: string | undefined }) => {
  const { visitId } = props;
  const [isPhotoCaptureOpen, setIsPhotoCaptureOpen] = useState(false);
  const { data: photos = [] } = usePhotosQuery(visitId!);
  const uploadPhotoMutation = useUploadPhotoMutation();
  const deletePhotoMutation = useDeletePhotoMutation();

  const handlePhotoCapture = async (imageData: string, description?: string) => {
    await uploadPhotoMutation.mutateAsync({
      visitId: visitId!,
      imageData,
      description,
    });
  };

  const handlePhotoDelete = async (photoId: string, photoUrl: string) => {
    await deletePhotoMutation.mutateAsync({
      photoId,
      photoUrl,
      visitId: visitId!,
    });
  };
  return (
    <>
      <Divider
        sx={{
          '& .MuiDivider-wrapper': {
            fontSize: '0.80rem',
            fontFamily: 'Roboto, sans-serif',
            fontWeight: 600,
            lineHeight: 1.5,
            color: 'primary.main',
            paddingTop: 3,
            paddingBottom: 1,
          },
        }}
      >
        <FormattedMessage defaultMessage="Fotografie účesu" id="visitDetail.photos" />
      </Divider>
      <Stack spacing={2}>
        <Box>
          <Button
            variant="outlined"
            startIcon={<PhotoCameraIcon />}
            onClick={() => setIsPhotoCaptureOpen(true)}
            fullWidth
          >
            <FormattedMessage defaultMessage="Přidat fotografii" id="visitDetail.addPhoto" />
          </Button>
        </Box>
        <HairstylePhotoGallery photos={photos} onDelete={handlePhotoDelete} />
      </Stack>
      <HairstylePhotoCapture
        open={isPhotoCaptureOpen}
        onClose={() => setIsPhotoCaptureOpen(false)}
        onCapture={handlePhotoCapture}
      />
    </>
  );
};

export default VisitDetailPhoto;
